var _rect, _text, _rect2, _text2, _rect3, _text3, _rect4, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemoryMatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 32,
    height: 36,
    rx: 5,
    fill: "#C75E5A"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 43,
    fontFamily: "sans-serif",
    fontSize: 20,
    fill: "white",
    textAnchor: "middle"
  }, "\u2605")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 20,
    width: 32,
    height: 36,
    rx: 5,
    fill: "#FAC1B5"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 43,
    fontFamily: "sans-serif",
    fontSize: 18,
    fill: "#C75E5A",
    textAnchor: "middle"
  }, "?")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 62,
    width: 32,
    height: 36,
    rx: 5,
    fill: "#FAC1B5"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 85,
    fontFamily: "sans-serif",
    fontSize: 18,
    fill: "#C75E5A",
    textAnchor: "middle"
  }, "?")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 62,
    width: 32,
    height: 36,
    rx: 5,
    fill: "#C75E5A"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 85,
    fontFamily: "sans-serif",
    fontSize: 20,
    fill: "white",
    textAnchor: "middle"
  }, "\u2605")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoryMatch);
export default __webpack_public_path__ + "static/media/MemoryMatch.430478ad84dfbdded569ddda0655d61d.svg";
export { ForwardRef as ReactComponent };